/* eslint-disable no-unreachable */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LanguageContext } from '../../../../../libs/Context';
import { useDispatch, useSelector } from 'react-redux';
import { setDownloadFile, setZipFile } from '../../../../../redux/MediakitRedux';
import useMediaDriveFun from '../../../customHooks/MediaDriveFunctions';
import { catchErr, datetimeFormat, sanitizeFileName } from '../../../../../libs/HelperContent';
import { saveAs } from 'file-saver';
import { Storage, Hub } from 'aws-amplify';
import { existFolder } from '../../../../actions/media_actions';
import { useParams } from 'react-router-dom';
import JSZip from 'jszip';
import useUpload from '../../../customHooks/useUpload';
import { toast } from 'react-toastify';
import useUpdateStorage from '../../../../LicenseSubscription/customHooks/useGetStorage';

const ZippedFiles = (props) =>
{
	const { setMediaState } = props;
	const { language } = useContext(LanguageContext);
	const folderId = useParams()?.id || '';
	const tab = useParams()?.tab || '';
	const { folderData } = useSelector((state: any) => state?.mymediakit?.mediaKitData);
	const handleUploadFiles = useUpload(folderData);

	const [ downloadInfo, setDownloadInfo ] = useState({
		name              : '',
		percent           : 0,
		bytesUploaded     : 0,
		totalSize      	  : 0,
		start             : false,
		type              : '',
		zippingFiles      : false,
		downloadInterrupt : false,
		status            : ''
	});
	const userData = useSelector((state:any) => state.mysession.session);
	const { downloadFile, zipFile } = useSelector((state:any) => state.mymediakit);
	const dispatch = useDispatch();
	const tempFileInfo:any = useRef(downloadInfo);
	const { getInsideFoldersList } = useMediaDriveFun({});
	const setStorageData = useUpdateStorage();

	const handleClose = () =>
	{
		dispatch(setDownloadFile([]));
		dispatch(setZipFile([]));
		setMediaState({ type: 'updateReducer', payload: { selectedData: [] } });
	};

	const downloadRef:any = useRef(null);
	const hubListenerCancelToken = useRef(() => {});

	const handleRemoveSize = (types = 'add') =>
	{
		Storage.cancel(downloadRef.current, 'Cancelled by user');
		const prevUnfinishedUploads = JSON.parse(localStorage.getItem('unfinishedUploads') ?? '{}');

		const updatedUnfinishedUpload = { ...prevUnfinishedUploads, [userData?.companyId]: (prevUnfinishedUploads[userData?.companyId] || 0) + (types === 'del' ? -1 : 1) * downloadInfo?.totalSize };

		localStorage.setItem('unfinishedUploads', JSON.stringify(updatedUnfinishedUpload));
	};

	const beforeUnloadFunc = () =>
	{
		handleRemoveSize();
	};

	const updateStatus = (data) =>
	{
		tempFileInfo.current = { ...tempFileInfo.current, ...data };
		setDownloadInfo(tempFileInfo.current);
	};

	const downloadFileUsingKey = async (data:any) =>
	{
		const newUrl:any = new URL(data?.url);

		Storage.configure({
			bucket       : newUrl?.origin === process.env.REACT_APP_OLD_S3_BASE_URL ? process.env.REACT_APP_OLD_S3_BUCKET : process.env.REACT_APP_S3_BUCKET,
			customPrefix : {
				public : newUrl?.origin === process.env.REACT_APP_OLD_S3_BASE_URL ? `${process.env.REACT_APP_STAGE}/resources-mediakit/` : ''
			},
			region : newUrl?.origin === process.env.REACT_APP_OLD_S3_BASE_URL ? process.env.REACT_APP_S3_OLD_BUCKET_REGION : process.env.REACT_APP_S3_BUCKET_REGION

		});

		let fileSizeUptoLastUpload = 0;

		const progressCallback = (progress) =>
		{
			let percent = Math.round(
				((fileSizeUptoLastUpload + progress.loaded) / (tempFileInfo.current?.totalSize || 1)) * 100
			);

			if (tempFileInfo.current?.type === 'zip') percent = percent / 2;

			percent > 0 && updateStatus({ percent, loading: false, bytesUploaded: fileSizeUptoLastUpload + progress.loaded });

			if ((progress.loaded === progress.total))
			{
				fileSizeUptoLastUpload += progress.total;
			}
		};

		downloadRef.current = Storage.get(data?.key, { download: true, progressCallback });
		const downloadedFile = await downloadRef.current;

		return downloadedFile;
	};

	const convertNestedZip = async (nestedD:any, zippedD:any) =>
	{
		for (const data of nestedD)
		{
			const isFile = Object.keys(data?.media).length > 0;
			const name = data?.name;

			if (isFile)
			{
				const s3Obj = await downloadFileUsingKey(data?.media);

				await zippedD.file(name, s3Obj.Body, { binary: true });
			}
			else
			{
				const folder = zippedD.folder(name);

				if (data?.folders?.length > 0)
				{
					await convertNestedZip(data?.folders, folder);
				}
			}
		}

		return zippedD;
	};

	const convertZip = async (nestedD:any, alrdyExist:boolean) =>
	{
		const prsntDate = new Date();
		const date = datetimeFormat(prsntDate);
		let newName = '';

		const fileName = nestedD[0]?.name.split('.')[0];

		newName = alrdyExist ? `${fileName}_${date}.zip` : `${fileName}.zip`;

		updateStatus({ name: newName });

		const zip = new JSZip();
		const nestedZip = await convertNestedZip(nestedD, zip);
		let zipContent:any = [];

		// try
		// {
		zipContent = await nestedZip.generateAsync({ type: 'blob' }, (metadata:any) =>
		{
			if (metadata.currentFile)
			{
				if (downloadInfo?.downloadInterrupt)
				{
					return { action: 'cancel' };
				}
			}
		});

		zipContent.name = newName;

		return zipContent;
	};

	const uploadMediaFiles = async (mediaFile:any) =>
	{
		const totalSize = tempFileInfo.current?.totalSize;

		let fileSizeUptoLastUpload = 0;

		const progressCallback = (progress) =>
		{
			let percent = Math.round(
				((fileSizeUptoLastUpload + progress.loaded) / totalSize) * 100
			);

			if (tempFileInfo.current?.type === 'zip') percent = (percent / 2) + 50;

			updateStatus({ percent, loading: false, bytesUploaded: fileSizeUptoLastUpload + progress.loaded });

			if ((progress.loaded === progress.total))
			{
				fileSizeUptoLastUpload += progress.total;
			}
		};

		const errorCallback = (_err) =>
		{
			console.log('error**', _err);
			setStorageData({ action: 'del', size: mediaFile[0]?.size, ownerCompanyId: userData?.companyId });
		};

		Storage.configure({
			bucket : process.env.REACT_APP_S3_BUCKET,
			region : process.env.REACT_APP_S3_BUCKET_REGION
		});

		const resultArray:any = [];

		for (const File of mediaFile)
		{
			const customPrefix = { public: `${userData?.companyId}/drive/` };

			const sanitizedKey = sanitizeFileName(`${new Date().valueOf()}_${File?.name.replace(' ', '_')}`);
			let result:any = Storage.put(sanitizedKey, File, { customPrefix, contentType: File.type, progressCallback, errorCallback });

			downloadRef.current = result;
			result = await result;

			resultArray.push({
				url   : `${process.env.REACT_APP_S3_BASE_URL}/${userData?.companyId}/drive/${result.key}`,
				type  : File.type,
				key   : `${userData?.companyId}/drive/${result.key}`,
				title : File.name,
				name  : File.name,
				size 	: File.size
			});
		}

		return resultArray;
	};

	const addMediaType = (media) =>
	{
		const newMedia: any = [];

		media?.forEach((item: any) =>
		{
			switch (item?.type.split('/')[0])
			{
				case ('application'):
				case ('text'):
					newMedia.push({ ...item, mediaType: 2 });
					break;
				case ('image'):
					newMedia.push({ ...item, mediaType: 3 });
					break;
				case ('audio'):
					newMedia.push({ ...item, mediaType: 4 });
					break;
				case ('video'):
					newMedia.push({ ...item, mediaType: 5 });
					break;
				default:
					newMedia.push({ ...item, mediaType: 1 });
					break;
			}
		});

		return newMedia;
	};

	const handleZip = async (fileData:any) =>
	{
		const { nestedFoldersData, downloadSize } = await getInsideFoldersList(fileData);

		const lic:any = await setStorageData({ action: 'add', size: downloadSize, ownerCompanyId: userData?.companyId });

		if (lic?.statusCode === 507)
		{
			handleClose();

			return;
		}

		updateStatus({ start: true, type: 'zip', status: 'inprogress', totalSize: downloadSize });

		let checkExistName = '';

		const fileName = fileData[0]?.name.split('.')[0];

		checkExistName = `${fileName}.zip`;

		const body:any = {
			name   : [ checkExistName ],
			parent : folderId,
			type   : 1
		};

		const query = {
			uid        : userData?.userId,
			comid      : userData?.companyId,
			empRole    : userData?.empRole,
			role       : userData?.role,
			actionType : 'create'

		};

		try
		{
			const checkExist = await existFolder(query, body);

			const zipContent = await convertZip(nestedFoldersData, checkExist?.data?.length !== 0);

			const file = new File([ zipContent ], zipContent.name, { type: zipContent.type, lastModified: Date.now() });

			const upload = await uploadMediaFiles([ file ]);

			const media = addMediaType(upload);

			handleUploadFiles(media, fileData[0]?.parent)
				.then((res) =>
				{
					if (res?.status)
					{
						toast.success(tab === 'folder' ? language?.fileConvertedZip : language?.fileConvertedZipSaved, {
							position : toast.POSITION.TOP_RIGHT
						});
						handleClose();
					}
				}
				);
		}
		catch (err)
		{
			catchErr(err);
		}

		handleClose();
		window.removeEventListener('beforeunload', beforeUnloadFunc);
		hubListenerCancelToken.current();
	};

	const handleDownload = async (fileData) =>
	{
		if (fileData?.length === 1 && fileData[0].type === 1)
		{
			updateStatus({ name: fileData[0]?.name, start: true, percent: 0, type: 'download', status: 'inprogress', totalSize: fileData[0]?.media?.size });

			try
			{
				const resultData:any = await downloadFileUsingKey(fileData[0].media);
				const urlData = URL.createObjectURL(resultData?.Body);
				const linkEle:any = document.createElement('a');

				linkEle.href = urlData;
				linkEle.download = fileData[0].media.name;
				linkEle.target = '_blank';
				linkEle.click();
				handleClose();
			}
			catch (err)
			{
				catchErr(err);
			}

			return;
		}
		let newName = '';

		if (fileData && fileData[0]?.type === 0)
		{
			newName = fileData[0]?.name;
		}
		else if (fileData && fileData[0]?.type === 1)
		{
			const findIndex = fileData[0]?.name?.lastIndexOf('.');

			newName = findIndex > 0 ? fileData[0]?.name?.slice(findIndex, 1) : fileData[0]?.name;
		}
		newName.concat('.zip');

		const { nestedFoldersData, downloadSize } = await getInsideFoldersList(fileData);

		updateStatus({ name: newName, start: true, type: 'download', status: 'inprogress', totalSize: downloadSize });

		const zipContent = await convertZip(nestedFoldersData, false);

		saveAs(zipContent, `${fileData[0].type === 1 ? fileData[0].media.name : fileData[0].name}.zip`);

		handleClose();
	};

	useEffect(() =>
	{
		downloadFile?.length > 0 && handleDownload(downloadFile);
	}, [ downloadFile ]);

	useEffect(() =>
	{
		zipFile?.length > 0 && handleZip(zipFile);
	}, [ zipFile ]);

	const closeByInterruption = () =>
	{
		Storage.cancel(downloadRef.current, 'zipping cancelled');
		downloadInfo?.type === 'zip' && setStorageData({ action: 'del', size: downloadInfo?.totalSize, ownerCompanyId: userData?.companyId });
		handleClose();
	};

	useEffect(() =>
	{
		if (downloadInfo.downloadInterrupt && downloadRef.current)
		{
			closeByInterruption();
		}
	}, [ downloadInfo.downloadInterrupt ]);

	const listener = (data) =>
	{
		if (data?.payload?.event === 'signOut')
		{
			beforeUnloadFunc();
			window.removeEventListener('beforeunload', beforeUnloadFunc);
		}
	};

	useEffect(() =>
	{
		downloadInfo?.type === 'zip' && window.addEventListener('beforeunload', beforeUnloadFunc);

		return () =>
		{
			window.removeEventListener('beforeunload', beforeUnloadFunc);
		};
	}, [ downloadInfo?.totalSize ]);

	return (
		<Dialog open fullWidth>
			<DialogTitle>
				<div className='flexRow'>
					<div className='flexMinWidthRow'>{downloadInfo?.type === 'download' ? `${language?.downloading}...` : language.zippingFiles}</div>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && updateStatus({ downloadInterrupt: true }); }} className='flexAutoRow pointer'
						onClick={() =>
						{
							updateStatus({ downloadInterrupt: true });
						}}
					>
						<CloseIcon />
					</button>
				</div>
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<span className='mrgnVMD'>
						<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: 'black', marginBottom: 'var(--pixel8)', fontSize: '1.125rem' }}>
							<Box sx={{ minWidth: 50 }}>

								{downloadInfo?.name}
							</Box>
							<Box sx={{ minWidth: 20 }}>
								<Typography variant='body2' color='text.primary'>
									{downloadInfo?.percent !== 0 && `${Math.round(downloadInfo?.percent)}%` }

								</Typography>
							</Box>
						</Box>
					</span>
				</DialogContentText>
				<DialogContentText>
					<span className='progressBar'>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<Box sx={{ width: 'var(--percent100)', mr: 1 }}>
								<LinearProgress variant='determinate' value={downloadInfo?.percent}/>
							</Box>
						</Box>
					</span>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ margin: '0.5rem 1rem' }}>
				<Button tabIndex={0} disableElevation disableRipple sx={{ width: '6rem', color: 'white' }} variant='contained'
					onKeyUp={() =>
					{
						downloadInfo?.type === 'zip' && window.addEventListener('beforeunload', beforeUnloadFunc);
						hubListenerCancelToken.current = downloadInfo?.type === 'zip' ? Hub.listen('auth', listener) : () => {};
						handleClose();
					}}
					onClick={() =>
					{
						downloadInfo?.type === 'zip' && window.addEventListener('beforeunload', beforeUnloadFunc);
						hubListenerCancelToken.current = downloadInfo?.type === 'zip' ? Hub.listen('auth', listener) : () => {};
						handleClose();
					}}
				>
					{language.ok}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ZippedFiles;